import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Apollo} from 'apollo-angular';
import { GET_PROGRAMRULES_QUERY, IProgramRule } from '@ebb-v2/ebb-integration';
import { ProgramRuleApiService } from '../programrule-api.service';


@Injectable({
    providedIn: 'root'
  })
  export class ProgramRuleGqlService implements ProgramRuleApiService {

    constructor(
      private apollo: Apollo
    ) { }

    public getProgramRuleList(typeCodes: number[]): Observable<IProgramRule[]> {
      return this.apollo
        .query ({
          query: GET_PROGRAMRULES_QUERY,
           variables: { typeCodes },
          fetchPolicy: 'network-only'
        })
        .pipe(map(result => result.data['programRules'] as IProgramRule[]));
    }

  }
